<template>
  <div class="b-articles-filters">
    <div
      v-for="filter in filtersData"
      :key="filter.id"
      class="b-articles-filters__item">
      <input
        :id="filter.id"
        v-model="selectedFilter"
        type="radio"
        name="filters"
        :value="filter.value"
        :selected="filter.value === selectedFilter"
        @change="onFilterChange" />
      <label
        :for="filter.id"
        :class="{ selected: filter.value === selectedFilter }">
        {{ filter.label }}
      </label>
    </div>
    <div v-if="yearFilter" class="b-articles-filters__item">
      <select class="form-select" v-model="selectedYear" @change="onFilterChange">
        <option
          v-for="year in yearFilter"
          :key="year"
          :value="year.value"
          :selected="year === yearFilter.selected">
          {{ year.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'

export default {
  emits: ['change-filters'],
  data() {
    return {
      selectedFilter: '',
      selectedYear: '',
      filtersData: [],
      yearFilter: [],
    }
  },
  mounted() {
    const { filters, yearFilter } = lib.getData('articlesOverviewData')
    this.filtersData = filters
    this.yearFilter = yearFilter

    this.setPreselectedValues()
  },
  methods: {
    setPreselectedValues() {
      if (lib.getUrlParam('filter')) {
        this.selectedFilter = lib.getUrlParam('filter')
      } else {
        this.selectedFilter = this.filtersData.find(
          (item) => item.selected
        ).value
      }

      if (lib.getUrlParam('year')) {
        this.selectedYear = lib.getUrlParam('year')
      } else {
        this.selectedYear = this.yearFilter.find((item) => item.selected).value
      }
    },

    onFilterChange() {
      this.$emit('change-filters', this.selectedFilter, this.selectedYear)
    },
  },
}
</script>
